import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9b6f831e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-row justify-between mx-auto max-w-500" }
const _hoisted_2 = ["href", "title"]
const _hoisted_3 = ["href", "title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_c_icon = _resolveComponent("c-icon")!
  const _component_ClipboardCopy = _resolveComponent("ClipboardCopy")!
  const _component_BaseDialog = _resolveComponent("BaseDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_BaseDialog, {
      "is-open": _ctx.showDefaultWishListShare,
      "onUpdate:is-open": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showDefaultWishListShare) = $event)),
      title: _ctx.labels.shareConfirmText
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("a", {
            class: "share-call-to-action",
            href: _ctx.pinterestShareLink(_ctx.shareUrl, _ctx.shareImage),
            title: _ctx.$dictionary.get('global/generic/pinterest'),
            target: "_blank"
          }, [
            _createVNode(_component_c_icon, {
              name: "icon-some-pinterest",
              class: "mb-20 w-30 h-30 xl:w-40 xl:h-40"
            }),
            _createElementVNode("p", null, _toDisplayString(_ctx.$dictionary.get('global/generic/pinterest')), 1)
          ], 8, _hoisted_2),
          _createElementVNode("a", {
            class: "share-call-to-action",
            href: _ctx.emailShareLink(_ctx.shareUrl, _ctx.labels.emailSubject, _ctx.labels.emailTextContent),
            title: _ctx.$dictionary.get('global/generic/email'),
            target: "_blank"
          }, [
            _createVNode(_component_c_icon, {
              name: "icon-some-mail",
              class: "mb-20 w-30 h-30 xl:w-40 xl:h-40"
            }),
            _createElementVNode("p", null, _toDisplayString(_ctx.$dictionary.get('global/generic/email')), 1)
          ], 8, _hoisted_3),
          _createVNode(_component_ClipboardCopy, { text: _ctx.shareUrl }, null, 8, ["text"])
        ])
      ]),
      _: 1
    }, 8, ["is-open", "title"]),
    _createElementVNode("button", {
      type: "button",
      class: "c-magic-line text-dusty-grey",
      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.showDefaultWishListShare = true), ["prevent"]))
    }, _toDisplayString(_ctx.labels.shareListBtn), 1)
  ], 64))
}